import React from 'react';
import { Tab, Tabs, TabList, TabPanel  } from 'react-tabs';
import { Accordion } from 'react-bootstrap-accordion'

const FAQ2 = (props) => {

    const data = props.data;

    return (
        <section className="tf-section faq">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="block-text center">
                        <h1 className="heading-bg" data-aos="fade-in" data-aos-duration="1000"><span>WEB</span></h1>
                        <h5 className="sub-title mb-10" data-aos="fade-up" data-aos-duration="1000">DEVELOPMENT</h5>
                        <h3 className="title mb-28" data-aos="fade-up" data-aos-duration="1000">front-end specialist <br /> web3 ready</h3>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <div className="flat-tabs" data-aos="fade-up" data-aos-duration="800">

                    <Tabs>
                        <TabList>
                        <Tab>websites</Tab>
                        <Tab>web graphics</Tab>
                        <Tab>blockchain</Tab>
                        <Tab>programming</Tab>
                        </TabList>

                        <TabPanel>
                            {
                                data.map((data,index) => (
                                    <Accordion className="h5 toggle-title" key={index} title={data.title}  show={data.show}>
                                            <p className="fs-18">{data.text}</p>
                                        </Accordion>
                                ))
                            }  
                        </TabPanel>
                        <TabPanel>
                            {
                                data.map((data,index) => (
                                    <Accordion className="h5 toggle-title" key={index} title={data.title} >
                                            <p className="fs-18">{data.text}</p>
                                        </Accordion>
                                ))
                            } 
                        </TabPanel>
                        <TabPanel>
                            {
                                data.map((data,index) => (
                                    <Accordion className="h5 toggle-title" key={index} title={data.title} >
                                            <p className="fs-18">{data.text}</p>
                                        </Accordion>
                                ))
                            } 
                        </TabPanel>
                        <TabPanel>
                            {
                                data.map((data,index) => (
                                    <Accordion className="h5 toggle-title" key={index} title={data.title} >
                                            <p className="fs-18">{data.text}</p>
                                        </Accordion>
                                ))
                            } 
                        </TabPanel>
                    </Tabs>
                    </div> 
                </div>
            </div>
        </div>
    </section>
    );
}

export default FAQ2;